function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "basic",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(0.032,0,0,0.032,0,10)",
    stroke: "none",
    style: {
      fill: "#95a5a6"
    },
    d: "M 152 221 C 110 221 76 255 76 297 C 76 339 110 373 152 373 C 194 373 228 339 228 297 C 228 255 194 221 152 221 z M 152 329 C 134 329 120 314 120 297 C 120 279 134 264 152 264 C 170 264 184 279 184 297 C 184 314 170 329 152 329 z M 822 221 C 779 221 745 255 745 297 C 745 339 779 373 822 373 C 864 373 898 339 898 297 C 898 255 864 221 822 221 z M 822 329 C 804 329 789 314 789 297 C 789 279 804 264 822 264 C 839 264 854 279 854 297 C 854 314 839 329 822 329 z M 779 112 C 779 112 591 25 531 12 C 471 0 266 11 246 24 L 131 80 L 18 135 L 0 242 C 0 242 0 305 4 319 L 59 319 L 60 297 C 60 246 101 205 152 205 C 203 205 244 246 244 297 L 246 319 L 729 319 L 729 291 C 729 240 768 202 819 202 C 870 202 914 240 914 291 L 916 317 C 916 317 974 320 993 314 C 993 314 1000 216 964 180 C 932 150 868 131 779 112 z M 256 126 C 256 126 280 76 306 57 C 325 41 430 41 430 41 L 434 138 L 256 126 z M 713 149 L 466 139 L 460 41 C 551 37 656 86 715 121 C 775 157 713 149 713 149 z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarIcon);
export default __webpack_public_path__ + "static/media/car-icon.0227a4f89b9dae80351a3cab647b6402.svg";
export { ForwardRef as ReactComponent };